import React from "react";

import Tag from "antd/es/tag";

import { Activity } from "@mapmycustomers/shared/types/entity";

import ActivityAssignee from "@app/component/activity/ActivityAssignee";
import ActivityName from "@app/component/activity/ActivityName";
import { formatRawDate } from "@app/util/formatters";

import styles from "../EntityListModal.module.scss";

import { ColumnsFactory } from "./ColumnsFactory";

export const createActivityListColumns: ColumnsFactory<Activity> = (
  intl,
  { onCompanyPreview, onDealPreview, onPersonPreview }
) => [
  {
    dataIndex: "activity",
    key: "activity",
    render: (ignore: any, activity: Activity) => (
      <ActivityName
        activity={activity}
        onCompanyClick={onCompanyPreview}
        onDealClick={onDealPreview}
        onPersonClick={onPersonPreview}
      />
    ),
    title: intl.formatMessage({
      id: "reports.overview.activityList.column.activity",
      defaultMessage: "Activity",
      description:
        "Title of a Activity column in Company table on Activities Modal on Overview page",
    }),
  },
  {
    className: styles.secondaryCol,
    dataIndex: "note",
    key: "note",
    title: intl.formatMessage({
      id: "reports.overview.activityList.column.note",
      defaultMessage: "Note",
      description: "Title of a Note column in Company table on Activities Modal on Overview page",
    }),
  },

  {
    dataIndex: "completedAt",
    key: "completedAt",
    render: (completedAt: Activity["completedAt"]) => (
      <Tag color="success">{formatRawDate(completedAt, "PPPpp")}</Tag>
    ),
    title: intl.formatMessage({
      id: "reports.overview.activityList.column.completedAt",
      defaultMessage: "Done at",
      description:
        "Title of a Done at column in Company table on Activities Modal on Overview page",
    }),
  },
  {
    dataIndex: "assignee",
    key: "assignee",
    render: (name, activity) => <ActivityAssignee activity={activity} />,
    title: intl.formatMessage({
      id: "reports.overview.activityList.column.assignee",
      defaultMessage: "Assigned to",
      description:
        "Title of Assigned to column in Activity table on Activities Modal on Overview page",
    }),
    width: "15%",
  },
];
